import React, { Component } from 'react'
import { cryptInfo } from '../config'
import { Upload } from '../components/payslips/Uploads'

import DonwloadPDF from '../components/payslips/DownloadPDFService'
import GenerateSlip from '../components/payslips/GenerateSlip'

const createPdf = (html) => DonwloadPDF.printPdf(html, 'pay_slip')

class PayslipsContainer extends Component {
	state = {
		isAdmin: cryptInfo.decrypt(localStorage.getItem('role')) === 'admin',
	}
	render() {
		const { isAdmin } = this.state
		return (
			<div>
				{isAdmin && <Upload />}
				{isAdmin && <GenerateSlip createPdf={createPdf}/>}
			</div>
		);
	}
}

export default PayslipsContainer;